import { Anchor, AppShell, Group } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import sparkFullLogo from "../assets/images/spark_full_logo_white.svg";
import sparkIcon from "../assets/images/spark_icon_white.svg";
import UserMenuComponent from "./UserMenuComponent";
import ProspectSearch from "./ProspectSearch";

export interface HeaderComponentProps {
  isCollapsed?: boolean;
}
export default function HeaderComponent({ isCollapsed }: HeaderComponentProps) {
  return (
    <AppShell.Header withBorder bg={"white"}>
      <Group w="100%" h="100%" align="center" justify="space-between" gap="md">
        <Group h="100%" align="center" gap={0}>
          <Group
            align="center"
            justify="center"
            w={isCollapsed ? 60 : 170}
            h="100%"
            bg="optimaBlue.9"
          >
            <Anchor component={Link} to="/">
              <img src={isCollapsed ? sparkIcon : sparkFullLogo} />
            </Anchor>
          </Group>
        </Group>
        <ProspectSearch />
        <UserMenuComponent navIsCollapsed={isCollapsed} />
      </Group>
    </AppShell.Header>
  );
}
